import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { HarvestSample } from '@/types/Lot'

function useShowBinNumbers() {
  const route = useRoute()

  const showBinNumbers = ref(false)
  showBinNumbers.value = route.query['show_sample'] === '1'

  return { showBinNumbers }
}

function useShowProvisional() {
  const route = useRoute()

  const showProvisional = ref(false)
  showProvisional.value = route.query['show_provisional'] === '1'

  return { showProvisional }
}

function getBinDisplayString(harvestSample?: HarvestSample) {
  const route = useRoute()

  const binDisplayString = computed(() => {
    if (route.query['show_sample'] === '1') {
      return harvestSample?.bin ?? 'N/A'
    } else {
      return ''
    }
  })

  return binDisplayString.value
}

function buildQueryParamObject(
  showSample: boolean,
  lotNumbers: Array<string>,
  showProvisional: boolean = false
) {
  const queryParamObject = computed(() => {
    const queryParams: { 'lots[]': Array<string>; show_sample?: string; show_provisional?: string } = {
      'lots[]': lotNumbers
    }
    if (showSample) {
      queryParams.show_sample = '1'
    }
    if (showProvisional) {
      queryParams.show_provisional = '1'
    }
    return queryParams
  })

  return queryParamObject.value
}

export { useShowBinNumbers, useShowProvisional, getBinDisplayString, buildQueryParamObject }
